module.exports = __webpack_public_path__ + "img/tansuo.4ba0f01b.jpg";